import angular from 'angular';
import { EVENTS, EVENT_VALUES } from './constants/noflake/noflakeSchema';
import { broadcastNavigationToStep1, broadcastNavigationToStep2 } from './actions/page';
import { monitoringService, retailerSettingsService } from './services';
import { store } from './store';

let INITIAL_PAGE_LOAD_LOGIN = true;
let INITIAL_PAGE_LOAD_STEP_1 = true;

angular
  .module('appRoutes', [])
  .config([
    '$routeProvider',
    '$locationProvider',
    '$sceDelegateProvider',
    ($routeProvider, $locationProvider, $sceDelegateProvider) => {
      const pathArray = window.location.pathname.split('/');
      const retailerName = pathArray[1];

      $routeProvider
        .when(`/${retailerName}/:service_type`, {
          templateUrl: '/r2/views/main.html',
          controller: 'LoginPageController',
        })
        .when(`/${retailerName}/:service_type/step-1`, {
          controller: 'Step1Controller',
          templateUrl: '/r2/views/steps/step-1-new.html',
        })
        .when(`/${retailerName}/:service_type/step-2`, {
          controller: retailerSettingsService.getIsSimpleReturnsBasic() ? 'Step4Controller' : 'Step2Step3Controller',
          templateUrl: () => {
            if (retailerSettingsService.getIsSimpleReturnsBasic()) {
              return '/r2/views/steps/step-4.html';
            }
            return '/r2/views/steps/step-2-new.html';
          },
        })
        .when(`/${retailerName}/:service_type/step-3`, {
          controller: 'Step2Step3Controller',
          templateUrl: '/r2/views/steps/step-3-new.html',
        })
        .when(`/${retailerName}/:service_type/step-4`, {
          controller: 'Step4Controller',
          templateUrl: '/r2/views/steps/step-4.html',
        })
        .when(`/${retailerName}/:service_type/step-async-label`, {
          controller: 'StepAsyncLabelController',
          templateUrl: '/r2/views/steps/step-async-label.html',
        })
        .when(`/${retailerName}/returns/printerless-info`, {
          templateUrl: '/r2/views/printerless-info.html',
          controller: 'PrinterlessInfoController',
        })
        .when(`/${retailerName}/returns/faq/:feature`, {
          templateUrl: '/r2/views/faq-page.html',
          controller: 'FaqPageController',
        })
        .when(`/${retailerName}/returns/addons/pickups`, {
          templateUrl: '/r2/views/pickups.html',
          controller: 'PickupsPageController',
        })
        .otherwise({ redirectTo: `/${retailerName}/returns/` });

      $sceDelegateProvider.resourceUrlWhitelist([
        'https://assets.narvar.qa/**',
        'https://assets.narvar.com/**',
        'https://tracking.integrations-narvar.qa/**',
        'https://tracking.integrations-narvar.com/**',
      ]);

      $locationProvider.html5Mode(true);
    },
  ])
  .run([
    '$rootScope',
    '$location',
    ($rootScope, $location) => {
      $rootScope.$on('$locationChangeSuccess', () => {
        const INIT = $location.search().init;
        const pathArray = $location.path().split('/');
        const path = pathArray.slice(3).join('/');

        if (!(INITIAL_PAGE_LOAD_STEP_1 || INITIAL_PAGE_LOAD_LOGIN) || !INIT) {
          monitoringService.postData({
            type: EVENTS.PAGE_LOAD,
            value: EVENT_VALUES[EVENTS.PAGE_LOAD][path] || EVENT_VALUES[EVENTS.PAGE_LOAD].default,
          });
        }
        if (INIT && (INITIAL_PAGE_LOAD_STEP_1 || INITIAL_PAGE_LOAD_LOGIN)) {
          INITIAL_PAGE_LOAD_LOGIN = path === '';
          INITIAL_PAGE_LOAD_STEP_1 = path === 'step-1';
        }

        switch (path) {
          case 'step-1': {
            store.dispatch(broadcastNavigationToStep1());
            break;
          }

          case 'step-2': {
            store.dispatch(broadcastNavigationToStep2());
            break;
          }

          case 'step-3': {
            break;
          }

          case 'step-4': {
            break;
          }

          default:
            break;
        }
      });
    },
  ]);
